import React, { useState } from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import {
    Typography,
    FormControlLabel,
    Switch
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import * as Constants from "../common/Constants";
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import LinearProgress from '@material-ui/core/LinearProgress';
import Hidden from '@material-ui/core/Hidden';
import SchoolMgmtScr1 from "../assets/School-management1.PNG";
import SchoolMgmtScr2 from "../assets/School-management2.PNG";
import SuperScalper1 from "../assets/Super-scalper1.PNG";
import SuperScalper2 from "../assets/Super-scalper2.PNG";
import GitHubIcon from '@material-ui/icons/GitHub';
import { connect } from 'react-redux';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: "column",
        height: "100%",
        paddingLeft: "16px"
    },
    heading: {
        color: theme.palette.primary.textColor,
        width: "100%",
        fontWeight: 600,
        fontSize: "40px"
    },
    firstName: {
        color: theme.palette.primary.textColor,
        fontSize: "72px",
        fontWeight: 600
    },
    lastName: {
        color: theme.palette.primary.main,
        fontSize: "72px",
        fontWeight: 600
    },
    jobRoleDiv: {
        paddingTop: "24px",
        display: "flex",
        flexDirection: "column"
    },
    jobRole: {
        fontSize: "24px",
        display: "flex",
        flexDirection: "row",
        fontWeight: 600
    },
    fromToDate: {
        fontSize: "24px",
        fontWeight: 500,
        paddingLeft: "12px",
        marginLeft: "auto",
        color: theme.palette.primary.main
    },
    jobCompany: {
        paddingTop: "12px",
        textDecoration: "underline",
        fontSize: "20px",
        fontWeight: 500
    },
    skillBullets: {
        paddingTop: "12px",
        display: "flex",
        flexDirection: "column",
        paddingBottom: "12px"
    },
    designation: {
        fontSize: "22px",
        fontWeight: 500
    },
    checkList: {
        display: "flex",
        flexDirection: "row",
        alignItems: "top"
    },
    checkIcon: {
        fontSize: "16px",
        marginRight: "12px",
        marginTop: "4px"
    },
    checkIconBig: {
        fontSize: "16px",
        marginRight: "12px",
        marginTop: "10px"
    },
    programHeader: {
        display: "flex",
        flexDirection: "row",
        alignItems: "top",
        fontSize: "24px",
        fontWeight: 500
    },
    programContent: {
        marginLeft: "28px",
        display: "flex",
        alignItems: "top"
    },
    level: {
        width: "100px",
        height: "12px",
        marginLeft: "12px",
        marginTop: "6px"
    },
    expWith: {
        color: theme.palette.primary.main,
    },
    expWithLast: {
        color: theme.palette.primary.main,
        paddingBottom: "24px"
    },
    skillBulletLast: {
        paddingTop: "16px",
        paddingBottom: "36px",
        display: "flex",
        flexDirection: "column"
    },
    keyResponsibilities: {
        paddingTop: "12px",
        fontWeight: 600
    },
    screenshotsDiv: {
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(256px, 1fr))",
        gridGap: "24px"
    },
    screenshots: {
        width: "100%",
        border: "2px solid " + theme.palette.primary.main,
        borderRadius: "16px"
    },
    schoolmgmtscr: {
        width: "50%",
        border: "2px solid " + theme.palette.primary.main,
        borderRadius: "16px"
    },
    link: {
        color: theme.palette.primary.main,
        cursor: "pointer",
        "&:hover": {
            textDecoration: "underline",
        }
    },
    gitHubIcon: {
        cursor: "pointer",
        "&:hover": {
            color: theme.palette.primary.main
        }
    }
}));

const Interests = (props) => {
    const classes = useStyles();
    const navigateToContactInfo = () => {
        props.setSelectedItem("contact");
    }

    const openNewTab = (url) => {
        window.open(url, '_blank');
    }

    return (
        <Typography component="div" className={classes.root}>
            <Typography component="div" className={classes.heading}>INTERESTS</Typography>
            <Typography component="div" className={classes.jobRoleDiv}>
                <Typography component="span" className={classes.jobRole}>General</Typography>
            </Typography>
            <Typography component="div" className={classes.skillBullets}>
                <Typography component="span" className={classes.checkList} ><ArrowForwardIosIcon className={classes.checkIcon} />I like to play chess, solve sudoku puzzles, solve rubiks cube and play computer games.</Typography>
                <Typography component="span" className={classes.checkList} ><ArrowForwardIosIcon className={classes.checkIcon} />When it comes to outdoor activities, I like hiking and playing outdoor games like Volley ball and cricket.</Typography>
                <Typography component="span" className={classes.checkList} ><ArrowForwardIosIcon className={classes.checkIcon} />Interested in indoor games like Table tennis and Shuttle bad minton.</Typography>
                <Typography component="span" className={classes.checkList} ><ArrowForwardIosIcon className={classes.checkIcon} />In my free time I like to do pencil sketches and do side projects.</Typography>
            </Typography>

            <Typography component="div" className={classes.jobRoleDiv}>
                <Typography component="span" className={classes.jobRole}>Hobby projects</Typography>
                <Typography component="span" className={classes.jobCompany}>Zerodha Super Scalper</Typography>
            </Typography>
            <Typography component="div" className={classes.skillBullets}>
                <Typography component="span" className={classes.checkList} >Using Zerodha's kite connect APIs, I developed an application with an algorithm to minimize losses during a trade session.</Typography>
                <Typography component="span" className={classes.keyResponsibilities} >What I learnt:</Typography>
                <Typography component="span" className={classes.checkList} ><ArrowForwardIosIcon className={classes.checkIcon} />Using Node JS, I authenticated the Zerodha's trading account and connected to kite APIs for trading via my UI.</Typography>
                <Typography component="span" className={classes.checkList} ><ArrowForwardIosIcon className={classes.checkIcon} />Learnt how to write data to excel sheet and save it to output folder using "node-xlsx" package.</Typography>
                <Typography component="span" className={classes.checkList} ><ArrowForwardIosIcon className={classes.checkIcon} />With this application I could analyze the trades and minimize the losses for volatile trades in selected days.</Typography>
                <Typography component="span" className={classes.checkList} ><ArrowForwardIosIcon className={classes.checkIcon} /><Typography component="span">For more information about this application, feel free to&nbsp;<a className={classes.link} onClick={navigateToContactInfo}>contact me</a>.</Typography></Typography>
                <Typography component="span" className={classes.keyResponsibilities} >Technologies:</Typography>
                <Typography component="span" className={classes.expWith}>React JS, Node JS, Zerodha's kite-connect APIs, HTML/CSS. </Typography>
                <Typography component="span" className={classes.keyResponsibilities} >Screenshots:</Typography>
                <Typography component="div" className={classes.screenshotsDiv} ><img src={SuperScalper1} className={classes.screenshots} /><img src={SuperScalper2} className={classes.screenshots} /></Typography>
            </Typography>

            <Typography component="div" className={classes.jobRoleDiv}>
                <Typography component="span" className={classes.jobCompany}>School management</Typography>
            </Typography>
            <Typography component="div" className={classes.skillBullets}>
                <Typography component="span" className={classes.checkList} >This was just a project I did in my free time to learn react-redux</Typography>
                <Typography component="span" className={classes.keyResponsibilities} >What I learnt:</Typography>
                <Typography component="span" className={classes.checkList} ><ArrowForwardIosIcon className={classes.checkIcon} />Learnt how to integrate "Sign in with google" for logging in to an application.</Typography>
                <Typography component="span" className={classes.checkList} ><ArrowForwardIosIcon className={classes.checkIcon} />Learnt react-redux and how to apply dark mode using Material UI.</Typography>
                <Typography component="span" className={classes.keyResponsibilities} >Technologies:</Typography>
                <Typography component="span" className={classes.expWith}>React JS, Node JS and Mongo DB. </Typography>
                <Typography component="span" className={classes.keyResponsibilities} >Screenshot:</Typography>
                {props.darkMode ? <><Hidden xsDown implementation="css"><Typography component="div" className={classes.screenshotsDiv} ><img src={SchoolMgmtScr1} className={classes.schoolmgmtscr} /></Typography></Hidden>
                    <Hidden smUp implementation="css"><Typography component="div" className={classes.screenshotsDiv} ><img src={SchoolMgmtScr1} className={classes.screenshots} /></Typography></Hidden></>
                    : <><Hidden xsDown implementation="css"><Typography component="div" className={classes.screenshotsDiv} ><img src={SchoolMgmtScr2} className={classes.schoolmgmtscr} /></Typography></Hidden>
                        <Hidden smUp implementation="css"><Typography component="div" className={classes.screenshotsDiv} ><img src={SchoolMgmtScr2} className={classes.screenshots} /></Typography></Hidden></>
                }
            </Typography>

            <Typography component="div" className={classes.jobRoleDiv}>
                <Typography component="span" className={classes.jobCompany}>My portfolio <GitHubIcon fontSize="small" onClick={() => openNewTab(Constants.GITHUB_PORTFOLIO)} className={classes.gitHubIcon} /></Typography>
            </Typography>
            <Typography component="div" className={classes.skillBullets}>
                <Typography component="span" className={classes.checkList} >The one which you are looking at now is the project developed by me in my free time.</Typography>
                <Typography component="span" className={classes.keyResponsibilities} >What I learnt:</Typography>
                <Typography component="span" className={classes.checkList} ><ArrowForwardIosIcon className={classes.checkIcon} />Learnt how to host a static page with GitHub Pages.</Typography>
                <Typography component="span" className={classes.checkList} ><ArrowForwardIosIcon className={classes.checkIcon} />Learnt a few things about React CSS Transition Groups.</Typography>
                <Typography component="span" className={classes.keyResponsibilities} >Technologies:</Typography>
                <Typography component="span" className={classes.expWith}>React JS</Typography>
            </Typography>

            <Typography component="div" className={classes.jobRoleDiv}>
                <Typography component="span" className={classes.jobCompany}>Event manager</Typography>
            </Typography>
            <Typography component="div" className={classes.skillBullets}>
                <Typography component="span" className={classes.checkList} >This was a side project I did for my friend as I wanted to revisit how to setup a project from scratch.</Typography>
                <Typography component="span" className={classes.keyResponsibilities} >What I learnt:</Typography>
                <Typography component="span" className={classes.checkList} ><ArrowForwardIosIcon className={classes.checkIcon} />With this project I was able to learn how to upload excel files from React JS.</Typography>
                <Typography component="span" className={classes.checkList} ><ArrowForwardIosIcon className={classes.checkIcon} />Parse the uploaded excel files in Node JS and save the data to Mongo DB.</Typography>
                <Typography component="span" className={classes.keyResponsibilities} >Technologies:</Typography>
                <Typography component="span" className={classes.expWithLast}>React JS, Node JS and Mongo DB. </Typography>
            </Typography>
        </Typography>
    );
}

const mapStateToProps = (state) => {
    return {
        darkMode: state.darkMode
    }
}

export default connect(mapStateToProps)(Interests);
